export default __webpack_public_path__ + "static/media/passwordgen.a50611c8.png";